import { connect } from "react-redux";
import { SpreadsheetProtocolSection as Component } from "./SpreadsheetProtocolSection";
import { setChapter } from "@learningblocks/exp-redux";

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setNoteBookSection: (sectionValue) => {
      dispatch(setChapter(sectionValue));
    },
  };
}

export const SpreadsheetProtocolSection = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
